import classNames from 'classnames'
import React from 'react'

interface IIndicator {
  align?: 'left' | 'right' | 'center'
  name: string
  value?: number
  className?: string
}

export default function Indicator(props: IIndicator) {
  const { align, name, value, className } = props

  return (
    <div className={classNames('indicator', className)}>
      <span className="name">{name}</span>
      {value && <span className="value">{Number(value).toFixed(1)}</span>}
      <style jsx>
        {`
          .indicator {
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            height: 32px;
          }
          .name {
            flex: 0 0 auto;
            font-size: 12px;
            line-height: 18px;
            color: #606370;
            transform: scale(0.833);
          }
          .value {
            flex: 0 0 auto;
            color: #979aa8;
            font-size: 12px;
            line-height: 14px;
            transform: scale(0.833);
            align-self: ${align === 'left'
      ? 'flex-start'
      : align === 'center'
        ? 'center'
        : 'flex-end'};
          }
        `}
      </style>
    </div>
  )
}
